import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Menu as MenuIcon } from 'lucide-react';

export default function SortableCategory({ category, children }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: category.id });
  
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  
  return (
    <div ref={setNodeRef} style={style} data-category-id={category.id} className="flex items-start gap-2">
      <button {...attributes} {...listeners} className="cursor-move p-2 hover:bg-gray-100 rounded mt-3" type="button">
        <MenuIcon className="w-4 h-4 text-gray-400" />
      </button>
      <div className="flex-1">{children}</div>
    </div>
  );
}
